import qs from 'qs';
import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
/** Path segment for the audit-log resource. No area prefix. */
const AUDIT_LOG_PATH = 'audit-log';
// ---------------------------------------------------------------------------
// Endpoint
// ---------------------------------------------------------------------------
/**
 * RTK Query endpoint for audit log data.
 *
 * The audit-log endpoint is at `/audit-log?...` — there is no `areaId` path
 * prefix. `areaId` is an optional query filter.
 *
 * Date filter args (`startDate`, `endDate`) must be passed as numeric
 * millisecond timestamps rather than `Date` objects to keep RTK Query cache
 * keys stable.
 *
 * Array params (e.g. `ids`) are serialized with `{ arrayFormat: 'comma' }`
 * via `qs` to match the original client behaviour.
 *
 * @see https://redux-toolkit.js.org/rtk-query/api/created-api/code-splitting
 */
export const auditLogApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Fetches a paginated list of audit events.
         *
         * @endpoint GET /audit-log?{queryParams}
         * @returns AuditEventListResponse with `timestamp` fields converted to `Date`
         */
        getAuditEventList: builder.query({
            query: ({ page, perPage, ids, userId, type, areaId, action, searchTerm, startDate, endDate, }) => {
                const queryParams = qs.stringify({
                    page,
                    perPage,
                    ids,
                    userId,
                    config: type,
                    areaIds: areaId, // API param is named 'areaIds' but accepts a single string value — the plural name is misleading
                    action,
                    name: searchTerm,
                    dateFrom: startDate,
                    dateTo: endDate,
                }, { arrayFormat: 'comma' });
                return `/${AUDIT_LOG_PATH}?${queryParams}`;
            },
            transformResponse: (response) => (Object.assign(Object.assign({}, response), { items: response.items.map((dto) => (Object.assign(Object.assign({}, dto), { timestamp: new Date(Number(dto.timestamp)) }))) })),
            providesTags: [CC_API_TAGS.AuditEventList],
        }),
    }),
});
export const { useGetAuditEventListQuery, useLazyGetAuditEventListQuery } = auditLogApi;
